import { webRequestClient } from '@/services'
import { errorHandler } from '@/utils/helpers'
import { includes, isNil, map, remove, uniq } from 'lodash'

const actions = {
    // DATA RETRIEVAL
    checkCCloneLabels({ commit, rootState }, params) {
        const _params = {
            params: {
                list_limit: 0,
                order_direction: 'desc',
                order_fields: 'id',
                conditions: { account_id: rootState.accountId, label: params.label }
            }
        }
        return webRequestClient
            .get('/wousdat/strong_classifiers_families.json', _params)
            .then(response => response.list)
            .catch(error => errorHandler(error, commit))
    },

    closeCcloneCreationModal({ commit }) {
        commit('setDisplayModal', { modal: 'ccloneCreation', isDisplayed: false })
        commit('setDisplayModal', { modal: 'events', isDisplayed: false })
        commit('resetEventsStoreOnCcloneFormClose', {})
    },

    selectChildren({ commit, state, getters, rootState, rootGetters }, params) {
        let firstPartyData
        if (!isNil(params.item)) {
            const itemChildren = params.item.hasChild
                ? getters.getDescendantsJsonKeyNames({ level: Infinity, node: params.item, category: params.category })
                : []
            if (params.action === 'add') {
                firstPartyData = [...state.firstPartySelection, ...itemChildren, params.item.jsonKey.name]
            } else if (params.action === 'remove') {
                itemChildren.push(params.item.jsonKey.name)
                firstPartyData = remove(state.firstPartySelection, elem => !includes(itemChildren, elem))
            }
        } else {
            let data = []
            if (params.category === 'hierarchy') {
                data = rootGetters['data/customTaxonomies/getCurrentTaxonomyHierarchy']()
            } else {
                data = rootState.data[params.category].list
            }

            const dataToSelect = map(data, elem => elem.jsonKey.name)
            firstPartyData =
                params.action === 'add'
                    ? [...state.firstPartySelection, ...dataToSelect]
                    : remove(state.firstPartySelection, elem => !includes(dataToSelect, elem))
        }

        commit('setFirstPartySelection', { items: uniq(firstPartyData) })
    }
}

export default actions
